/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Price_SetupInputs */

const en_nav_price_setup = /** @type {(inputs: Nav_Price_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price setup`)
};

/**
* | output |
* | --- |
* | "Price setup" |
*
* @param {Nav_Price_SetupInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_price_setup = /** @type {((inputs?: Nav_Price_SetupInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Price_SetupInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_price_setup(inputs)
});